module.exports = __webpack_public_path__ + "img/registration-background.09b09398.svg";